import React, { useState, useEffect } from 'react';

interface SlideshowProps {
  images: string[];
}

const Slideshow: React.FC<SlideshowProps> = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (images.length <= 1) return; 

    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change slide every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [images.length]);

  return (
    <div className='adminRightSideAdbg'>
      {images.length > 0 && (
        // eslint-disable-next-line jsx-a11y/img-redundant-alt
        <img
          src={images[currentIndex]}
          alt={`adminRightSideAdbg Image ${currentIndex + 1}`}
          className='image'
        />
      )}
    </div>
  );
};


export default Slideshow;
